import React from "react";

class ConfirmFooter extends React.Component {
  render() {
    const { className } = this.props;
    return (
      <div className={`confirm-footer-container ${className || ""}`}>
        COPYRIGHT © NOMURA SECURITIES CO., LTD. ALL RIGHTS RESERVED
      </div>
    );
  }
}

export default ConfirmFooter;
